import { useParams, useLocation } from "react-router-dom";

export const useProjectId = (): string | null => {
  const params = useParams<{ projectId: string }>();
  const location = useLocation();

  // Caso o projectId não esteja nos parâmetros, tentamos extraí-lo da URL manualmente
  if (!params.projectId) {
    const match = location.pathname.match(/^\/([^/]+)/);
    return match ? match[1] : null;
  }

  return params.projectId || null;
};
